import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['icon', 'lastSynced']
  static values = { url: String }

  connect() {
    this.handleMorph = this.stopSpinner.bind(this)
    document.addEventListener('turbo:render', this.handleMorph)
  }

  disconnect() {
    document.removeEventListener('turbo:render', this.handleMorph)
  }

  async sync(event) {
    event.preventDefault()
    if (this.isSyncing) return

    this.isSyncing = true
    this.iconTarget.classList.add('fa-spin')

    try {
      await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })
    } catch (error) {
      console.error('Sync failed:', error)
      this.isSyncing = false
      this.iconTarget.classList.remove('fa-spin')
    }
  }

  stopSpinner() {
    this.isSyncing = false
    this.iconTarget.classList.remove('fa-spin')
  }
}